import { sizeEstimator } from "../../../components/cards/hooks/useGridCardDimensions";
import { Section } from "../../../types";

export function measureItemVertical(item: Section | undefined): number {
  if (!item) {
    return 0;
  }

  const { context, mode, size } = item.meta.layout.style;
  const dimensions = sizeEstimator(context, mode, size);

  // Use 64px to match the large screen bottomPadding used in measureElement.
  const rowPadding = 64;
  const sectionTitleHeight = item.description ? 88 : 56;

  return dimensions.height + rowPadding + sectionTitleHeight;
}

export function measureItemHorizontal(item: Section | undefined): number {
  if (!item) {
    return 0;
  }

  const { context, mode, size } = item.meta.layout.style;
  const dimensions = sizeEstimator(context, mode, size);

  return dimensions.width;
}
